import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import { push } from 'react-router-redux'
import { I18n } from 'react-redux-i18n'
import _ from 'lodash'

import api from 'core/api'
import { getAbilities } from 'modules/infos/abilities'
import { setupSessionProlongation } from 'modules/users/sessions/prolong'

const getType = type => `@users/sessions/${type}`

export const signInThunk = createActionThunk(
  getType('SIGN_IN'),
  api('/users/sessions', { method: 'POST' })
)

export const signIn = props => (dispatch, getStage) =>
  dispatch(signInThunk(props))
    .then(() => {
      const from = _.get(getStage(), 'routing.location.state.from', '/verification')
      dispatch(push(from))
      dispatch(toastr.add({ type: 'success', message: I18n.t('devise.sessions.signed_in') }))
      dispatch(getAbilities())
      dispatch(setupSessionProlongation())
    })
    .catch(res => {
      if (_.has(res, 'error.error.details') && _.isString(res.error.error.details))
        dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
      if (_.has(res, 'error.error.type') && res.error.error.type === 'validation_error')
        dispatch(toastr.add({ type: 'error', message: 'Validation error' }))
    })

export const setStage = createAction(getType('SIGN_IN_SET_STAGE'))

const isOtpRequiredError = action =>
  _.get(action, 'payload.error.error.type') === 'otp_required_error'
const getStage = (state, action) => (isOtpRequiredError(action) ? 1 : state.stage)

const initialState = { stage: 0 }

export default handleActions(
  {
    [signInThunk.FAILED]: (state, action) => ({
      ...state,
      ...action.payload,
      stage: getStage(state, action)
    }),
    [signInThunk.SUCCEEDED]: () => initialState,
    [setStage]: (state, { payload }) => ({ ...initialState, stage: payload })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/sessions/index.js